import { Action } from 'redux';
import { Map, Set, List, OrderedMap } from 'immutable';
import { Range } from 'react-input-range';
import { Moment } from 'moment';

import { Hotel, Rates } from '../../models/Hotels/Hotel';
import { Room, RoomGroup } from '../../models/Hotels/HotelRate';
import { SortType } from '../../models/Hotels/SortType';

import {
    SESSION_REQUEST,
    SESSION_RESPONSE,
    SESSION_ERROR,

    PAGE_REQUEST,
    PAGE_RESPONSE,
    PAGE_ERROR,

    PAGES_STATUS_REQUEST,
    PAGES_STATUS_RESPONSE,
    PAGES_STATUS_ERROR,

    SEARCH_STATUS_REQUEST,
    SEARCH_STATUS_RESPONSE,
    SEARCH_STATUS_ERROR,

    ROOMS_REQUEST,
    ROOMS_RESPONSE,
    ROOMS_ERROR,

    RESET_HOTELS,

    SET_CHECKIN,
    SET_CHECKOUT,
    SET_ADULTS,
    SET_CHILDREN,
    SET_HOTEL_ID,
    SET_REGION_ID,

    SET_CHILDRENS,
    PAGE_NUMBER,

    HOTEL_INFO_RESPONSE,
    HOTEL_INFO_REQUEST,
    HOTEL_INFO_ERROR,
} from '../../actions/Hotels/hotels';
import { SET_SORT_TYPE, SET_PRICE_RANGE, SET_STARS, SET_DISTANCE, RESET_FILTERS } from '../../actions/Hotels/filters';
import i18next from 'i18next';

export interface HotelsFiltersState {
    sortType: SortType;
    priceRange: Range;
    stars: Set<number>;
    distance: number;
}

export const initialFiltersState: HotelsFiltersState = {
    sortType: '',
    priceRange: {
        max: -1,
        min: -1
    },
    stars: Set<number>(),
    distance: 100
};

export interface HotelsState {
    sessionID: string | null;
    loadingSessionID: boolean;
    errorSessionID: string | null;

    pagesStatus: Object | null;
    loadingPagesStatus: boolean;
    errorPagesStatus: string | null;

    searchStatus: boolean;
    loadingSearchStatus: boolean;
    errorSearchStatus: string | null;

    hotels: Map<string, {
        rates: Rates,
        hotel: Hotel
    }>;
    loadingHotels: boolean;
    errorHotels: string | null;

    roomGroups: List<RoomGroup>;
    searchRoomsId: string | null;
    hotel: Hotel | null;
    loadingHotelInfo: boolean;
    errorHotelInfo: any;
    loadingRooms: boolean;
    errorRooms: string | null;

    filters: HotelsFiltersState;

    checkin: Moment | null;
    checkout: Moment | null;
    adults: number;
    children: number;
    hotelID: string | null;
    regionID: string | null;
    childrens: number[];
    page: number;
}

const initialState: HotelsState = {
    sessionID: null,
    loadingSessionID: false,
    errorSessionID: null,

    pagesStatus: null,
    loadingPagesStatus: false,
    errorPagesStatus: null,

    searchStatus: false,
    loadingSearchStatus: false,
    errorSearchStatus: null,

    hotels: Map<string, {
        rates: Rates,
        hotel: Hotel
    }>(),
    loadingHotels: false,
    errorHotels: null,

    roomGroups: List<RoomGroup>(),
    searchRoomsId: null,
    hotel: null,
    loadingHotelInfo: false,
    errorHotelInfo: null,
    loadingRooms: false,
    errorRooms: null,

    filters: initialFiltersState,

    checkin: null,
    checkout: null,
    adults: 1,
    children: 0,
    hotelID: null,
    regionID: null,
    childrens: [],
    page: 1,
};

export function hotelsState(state: HotelsState = initialState, action: Action) {
    switch (action.type) {
        case RESET_HOTELS: {
            return {
                ...state,
                sessionID: initialState.sessionID,
                loadingSessionID: initialState.loadingSessionID,
                errorSessionID: initialState.errorSessionID,

                pagesStatus: initialState.pagesStatus,
                loadingPagesStatus: false,
                errorPagesStatus: initialState.errorPagesStatus,

                hotels: initialState.hotels,
                loadingHotels: false,
                errorHotels: initialState.errorHotels
            };
        }

        case SET_SORT_TYPE: {
            const sortType = (action as any).sortType;
            return {
                ...state,
                filters: {
                    ...state.filters,
                    sortType
                }
            };
        }
        case SET_PRICE_RANGE: {
            const priceRange = (action as any).range;
            return {
                ...state,
                filters: {
                    ...state.filters,
                    priceRange
                }
            };
        }
        case SET_STARS: {
            const stars = (action as any).stars;
            return {
                ...state,
                filters: {
                    ...state.filters,
                    stars
                }
            };
        }
        case SET_DISTANCE: {
            const distance = (action as any).distance;
            return {
                ...state,
                filters: {
                    ...state.filters,
                    distance
                }
            };
        }
        case RESET_FILTERS: {
            return {
                ...state,
                filters: initialFiltersState
            };
        }

        case SESSION_REQUEST: {
            const {checkin, checkout, adults, children, regionID} = (action as any).params;
            return {
                ...state,
                loadingSessionID: true,
                sessionID: initialState.sessionID,
                errorSessionID: initialState.errorSessionID,

                filters: initialFiltersState,
                hotels: initialState.hotels,
                loadingHotels: initialState.loadingHotels,
                errorHotels: initialState.errorHotels,

                checkin: checkin,
                checkout: checkout,
                adults: adults,
                children: children,
                regionID: regionID,
                hotelID: null,
                searchStatus: initialState.searchStatus
            };
        }
        case SESSION_RESPONSE: {
            const response = (action as any).response;
            const result = response.result;
            return {
                ...state,
                loadingSessionID: false,
                sessionID: result ? result : null,
                page: initialState.page
            };
        }
        case SESSION_ERROR: {
            const errorSessionID = (action as any).error;
            return {
                ...state,
                loadingSessionID: false,
                errorSessionID
            };
        }

        case PAGES_STATUS_REQUEST: {
            return {
                ...state,
                loadingPagesStatus: true,
                pagesStatus: initialState.pagesStatus,
                errorPagesStatus: initialState.errorPagesStatus
            };
        }
        case PAGES_STATUS_RESPONSE: {
            const pagesStatus = (action as any).response.result;
            return {
                ...state,
                loadingPagesStatus: false,
                pagesStatus
            };
        }
        case PAGES_STATUS_ERROR: {
            const errorPagesStatus = (action as any).error;
            console.log(errorPagesStatus);
            alert(i18next.t('error_contact_konsierge'));
            return {
                ...state,
                loadingPagesStatus: false,
            };
        }
        case SEARCH_STATUS_REQUEST: {
            return {
                ...state,
                loadingSearchStatus: true,
                searchStatus: initialState.searchStatus,
                errorSearchStatus: initialState.errorSearchStatus
            };
        }
        case SEARCH_STATUS_RESPONSE: {
            const searchStatus = (action as any).response.result;
            return {
                ...state,
                loadingSearchStatus: false,
                searchStatus
            };
        }
        case SEARCH_STATUS_ERROR: {
            const errorSearchStatus = (action as any).error;
            console.log(errorSearchStatus);
            return {
                ...state,
                loadingSearchStatus: false,
                errorSearchStatus: errorSearchStatus
            };
        }

        case PAGE_REQUEST: {
            const pageID = (action as any).pageID;
            if (pageID === 1) {
                return {
                    ...state,
                    errorHotels: initialState.errorHotels
                };
            }
            return {
                ...state,
                errorHotels: initialState.errorHotels,
                loadingHotels: true
            };
        }
        case PAGE_RESPONSE: {
            const response = (action as any).response;
            const hotelsArr: Array<{
                rates: Rates,
                hotel: Hotel
            }> = response.result;
            let hotels = state.hotels;
            if (hotelsArr) {
                hotelsArr.forEach((item) => {
                    if (item.hotel.hotel_id) {
                        if (!hotels.has(item.hotel.hotel_id)) {
                            hotels = hotels.set(item.hotel.hotel_id, item);
                        }
                    }
                });
            }
            return {
                ...state,
                hotels,
                loadingHotels: false,
                page: response.page.next_page,
            };
        }
        case PAGE_ERROR: {
            const errorHotels = (action as any).error;
            console.log(errorHotels);
            if (errorHotels.status !== 404) {
                alert(i18next.t('error_contact_konsierge'));
            }
            return {
                ...state,
                loadingHotels: false
            };
        }

        case ROOMS_REQUEST: {
            return {
                ...state,
                roomGroups: initialState.roomGroups,
                hotel: initialState.hotel,
                loadingRooms: true,
                searchRoomsId: initialState.searchRoomsId,
                errorRooms: initialState.errorRooms
            };
        }
        case ROOMS_RESPONSE: {
            const response = (action as any).response;
            const hotel: Hotel = response.result.hotel;
            const searchRoomsId = response.result.search_rooms_id;
            let roomGroups: List<RoomGroup> = initialState.roomGroups;
            response.result.room_groups.map(roomGroup => {
                let rooms: OrderedMap<string, Room> = OrderedMap<string, Room>();
                roomGroup.rates.map(rate => {
                    rooms = rooms.set(rate.book_hash, rate);
                });
                const group: RoomGroup = {
                    images: roomGroup.images,
                    room_amenities: roomGroup.room_amenities,
                    name_struct: roomGroup.name_struct,
                    rates: rooms,
                };
                roomGroups = roomGroups.push(group);
            });
            return {
                ...state,
                roomGroups,
                hotel,
                searchRoomsId,
                loadingRooms: false
            };
        }
        case ROOMS_ERROR: {
            const errorRooms = (action as any).error;
            console.log(errorRooms);
            return {
                ...state,
                roomGroups: initialState.roomGroups,
                loadingRooms: false,
                searchRoomsId: initialState.searchRoomsId,
                errorRooms
            };
        }

        case SET_CHECKIN: {
            const checkin = (action as any).checkin;
            return {
                ...state,
                checkin
            };
        }
        case SET_CHECKOUT: {
            const checkout = (action as any).checkout;
            return {
                ...state,
                checkout
            };
        }
        case SET_ADULTS: {
            const adults = (action as any).adults;
            return {
                ...state,
                adults
            };
        }
        case SET_CHILDREN: {
            const children = (action as any).children;
            return {
                ...state,
                children
            };
        }
        case SET_HOTEL_ID: {
            const hotelID = (action as any).hotelID;
            return {
                ...state,
                hotelID
            };
        }
        case SET_REGION_ID: {
            const regionID = (action as any).regionID;
            return {
                ...state,
                regionID
            };
        }
        case SET_CHILDRENS: {
            const {childrens} = (action as any);
            return {
                ...state,
                childrens
            };
        }
        case PAGE_NUMBER: {
            const page = (action as any).page;
            return {
                ...state,
                page
            };
        }
        case HOTEL_INFO_REQUEST: {
            return {
                ...state,
                loadingHotelInfo: true,
                errorHotelInfo: initialState.errorHotelInfo
            };
        }
        case HOTEL_INFO_RESPONSE: {
            const hotel = (action as any).response.result;
            return {
                ...state,
                hotel,
                loadingHotelInfo: false,
            };
        }
        case HOTEL_INFO_ERROR: {
            const errorHotelInfo = (action as any).error;
            console.log(errorHotelInfo);
            return {
                ...state,
                loadingHotelInfo: false,
                errorHotelInfo
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Hotels/hotels.ts